import { render, staticRenderFns } from "./PageEnd.vue?vue&type=template&id=4d0a48ee&scoped=true&"
import script from "./PageEnd.vue?vue&type=script&lang=js&"
export * from "./PageEnd.vue?vue&type=script&lang=js&"
import style0 from "./PageEnd.vue?vue&type=style&index=0&id=4d0a48ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a48ee",
  null
  
)

export default component.exports